// const base_url='http://192.168.1.11:2442'
const base_url='https://kidsgalleria.h2ndigital.com'
export {base_url}


const fetch_data = `${base_url}/api/fetch-product`;
export {fetch_data}